module.exports = __webpack_public_path__ + "static/img/quality_banner_phone.49d895e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quality_banner_phone.png
// module id = h508
// module chunks = 1